module.exports = __webpack_public_path__ + "img/asset3.82b6a0ed.png";